import { useState } from "react";
import "./login.css";
import { useNavigate } from "react-router-dom";
import { useMutation } from "@tanstack/react-query";
import { loginUser, userProfile } from "../../services/authService";
import { message } from "antd";
import logoDark from "../../assets/images/radarlogo.png";
const NewLogin = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  const [formData, setFormData] = useState({
    email: "",
    password: "",
    staySignedIn: false,
  });
  const [errors, setErrors] = useState({});
  const [showPassword, setShowPassword] = useState(false);

  const getUserProfile = useMutation({
    mutationFn: userProfile,
    onSuccess: ({ data }) => {
      if (data.has_company) {
        navigate("/home");
      } else {
        navigate("/company-details");
      }
    },
  });

  const loginMutation = useMutation({
    mutationFn: loginUser,
    onSuccess: ({ data }) => {
      localStorage.setItem("accessToken", data.access);
      localStorage.setItem("refreshToken", data.refresh);
      message.success("User logged in successfully");
      getUserProfile.mutate();
      setIsLoading(false);
    },
    onError: (error) => {
      setIsLoading(false);
      message.error(error.detail || "Login failed. Please try again.");
    },
  });

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({ ...formData, [name]: type === "checkbox" ? checked : value });
    setErrors({ ...errors, [name]: "" });
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.email) newErrors.email = "Email is required.";
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email))
      newErrors.email = "Invalid email format.";
    if (!formData.password) newErrors.password = "Password is required.";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      setIsLoading(true);
      loginMutation.mutate({
        email: formData.email,
        password: formData.password,
        stay_signed_in: formData.staySignedIn,
      });
    }
  };

  return (
    <div className="container-login login-form">
      <div className="container-login">
        <div className="signup-container-login">
          <img
            src={logoDark}
            alt="Logo"
            height={30}
            onClick={() => navigate("/")}
            style={{ cursor: "pointer", marginBottom: '1.5rem' }}
          /> {/* Placeholder for logo */}
          <h2>Sign In to Your Account</h2>
          <p>Access Your Insights</p>
          <form className="signup-form" onSubmit={handleSubmit}>
            <div className="form-group">
              <input
                type="email"
                name="email"
                placeholder="Work Email (e.g., name@company.com)"
                value={formData.email}
                onChange={handleInputChange}
                required
              />
              {errors.email && <span className="error">{errors.email}</span>}
            </div>
            <div className="form-group password-group">
              <input
                type={showPassword ? "text" : "password"}
                name="password"
                placeholder="Password"
                value={formData.password}
                onChange={handleInputChange}
                required
              />
              <span className="eye-icon" onClick={togglePasswordVisibility}>
                {showPassword ? "👁️" : "👁️‍🗨️"}
              </span>
              {errors.password && (
                <span className="error">{errors.password}</span>
              )}
            </div>
            <label>
              <input
                type="checkbox"
                name="staySignedIn"
                checked={formData.staySignedIn}
                onChange={handleInputChange}
              />
              Stay signed in
            </label>
            <button type="submit">
              {isLoading ? "Signing in..." : `Sign in`}
            </button>
          </form>
          <p className="switch-link">
            Don’t have an account?{" "}
            <span onClick={() => navigate("/register")}>
              Sign up
            </span>
          </p>
        </div>
      </div>
      <footer>
        <div className="footer-links">
          <a href="/pricing">Pricing</a> | <a href="/">Features</a> |{" "}
          <a href="/">Contact</a>
        </div>
      </footer>
    </div>
  );
};

export default NewLogin;
